import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import "./ManageCategories.css";
import AdminNavBar from "./AdminNavBar";

const ManageCategories = () => {
  const [categories, setCategories] = useState([]);
  const [newCat, setNewCat] = useState("");

  useEffect(() => {
    async function load() {
      const snap = await getDocs(collection(db, "categories"));
      setCategories(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    }
    load();
  }, []);

  const addCategory = async () => {
    if (!newCat.trim()) return;
    await addDoc(collection(db, "categories"), { name: newCat });
    setNewCat("");
  };

  const deleteCategory = async (id) => {
    await deleteDoc(doc(db, "categories", id));
  };

  return (
    <div className="manage-home">

      <AdminNavBar />

      <div className="manage-categories">
        <h1>Manage Categories</h1>

        <div className="add-category">
          <input
            value={newCat}
            onChange={(e) => setNewCat(e.target.value)}
            placeholder="New category"
          />
          <button onClick={addCategory}>Add</button>
        </div>

        <ul>
          {categories.map((c) => (
            <li key={c.id}>
              {c.name}
              <button onClick={() => deleteCategory(c.id)}>Delete</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ManageCategories;
